<template>
  <div>
    <div
      class="smallpalette-container other-websites"
      @mouseover="onSponsorHover()"
      @mouseleave="onSponsorLeave()"
      v-if="isAd"
    >
      <div class="slider">
        <a
          @click.stop="selectSponsor(index, true)"
          :class="{ selected: index == lastSponsorNum }"
          v-for="(s, index) in enabledSponsors"
          :key="s.key"
          href="javascript:;"
        ></a>
      </div>
      <transition name="fade">
        <div class="loader-pie" v-if="nextSponsorTimer">
          <div class="leftHalf"></div>
          <div class="spinner"></div>
          <div class="rightHalf"></div>
        </div>
      </transition>
      <div class="website">
        <a
          @click="onSponsorClick()"
          :href="activeSponsor.link"
          target="_blank"
          class="curtain"
          :class="{noCurtain : activeSponsor.noCurtain}"
        >
          <span class="title">{{ activeSponsor.title }}</span>
          <span class="descr">{{ activeSponsor.descr }}</span>
        </a>
        <div
          class="image"
          :style="`background-image:url(${activeSponsor.image_url})`"
        ></div>
        <img
          v-if="activeSponsor.impressionLink"
          :src="activeSponsor.impressionLink"
          style="opacity:0;"
          alt=""
        />
      </div>
    </div>
    <router-link
      v-if="!isAd"
      :to="{ path: '/palette/' + paletteId }"
      class="smallpalette-container"
    >
      <div
        class="colors"
        @mouseover="animateEmoji()"
        @mouseleave="stopAnimateEmoji()"
      >
        <div
          class="color"
          v-for="color in palette.colors"
          :key="color.hex"
          :style="{ background: color.hex }"
        ></div>
        <div class="name">
          {{ paletteInfo.name }}
          <span class="emoji">{{ emoji }}</span>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
// import axios from 'axios';
import _ from "lodash";
import inView from "in-view";
import { sendActivity } from "@/api";

export default {
  name: "SmallPalette",
  components: {},
  props: {
    paletteId: String,
    palettes: Array,
    chunkIndex: Number
  },
  data() {
    return {
      palette: {},
      paletteInfo: {},
      emoji: "",
      emojiIndex: 0,
      interval: {},
      isAnimating: false,
      isAd: false,
      sponsors: [],
      activeSponsorImpressionLogged: false,
      activeSponsor: {
        title: "...",
        descr: "..."
      },
      lastSponsorNum: 0,
      nextSponsorTimer: null,
      nextSponsorDelayTimer: null,
      baseUrl: "//api.launchers.network"
      // baseUrl: 'http://127.0.0.1:8000',
    };
  },
  computed: {
    enabledSponsors: function() {
      return _.filter(this.sponsors, { disabled: false });
    }
  },
  beforeMount() {
    this.isAd = this.paletteId == "defo2" && this.chunkIndex == 1;
    if (!this.isAd) {
      this.palette = require(`@/data/palette-${this.paletteId}.json`);
      this.paletteInfo = _.find(this.palettes, { id: this.paletteId });
      this.emoji = this.paletteInfo.emoji;
    }
  },
  mounted() {
    const that = this;
    if (this.isAd) {

      let firstTime = false;
      if (localStorage.getItem("lastSponsorNum") === null) {
        localStorage.setItem("lastSponsorNum", 0);
        firstTime = true;
      } else {
        this.lastSponsorNum = parseInt(localStorage.getItem("lastSponsorNum"));
      }
      let url = this.baseUrl + "/serve";
      this.sponsors = [
        {
          key: "framer",
          title: "",
          short_title: "",
          link: "https://go.panda.network/framer-pn",
          impressionLink: "",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/framer.webp",
          disabled: false
        },
        {
          key: "webflow-1",
          title: "",
          short_title: "",
          link: "https://bit.ly/4c9nThf",
          impressionLink: "https://bit.ly/4bJHaWF",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/webflow-7.jpg",
          disabled: false
        }
      ];
      this.sponsorsDora = [
        {
          key: "dora-1",
          title: "",
          short_title: "",
          link: "https://bit.ly/4evUDD0",
          impressionLink: "https://bit.ly/4crHKbn",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/dora-ai.webp",
          disabled: false
        },
        {
          key: "dora-2",
          title: "",
          short_title: "",
          link: "https://bit.ly/3xnWvx2",
          impressionLink: "https://bit.ly/3KPnk0o",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/dora-3d.webp",
          disabled: false
        },
      ];
      this.sponsorsShared = [
        {
          key: "fairetype",
          title: "",
          short_title: "",
          link: "https://bit.ly/4faPC2m",
          impressionLink: "https://bit.ly/4fxHadZ",
          descr: "",
          image_url: "/static/other-sites/fairetype.webp",
          disabled: false
        },
        {
          key: "readymag",
          title: "",
          short_title: "",
          link: "https://bit.ly/3ygCzN4",
          impressionLink: "https://bit.ly/3yjEJLT",
          descr: "",
          image_url: "/static/other-sites/readymag.webp",
          disabled: false
        },
        {
          key: "raycast",
          title: "",
          short_title: "",
          link: "https://bit.ly/41bElLx",
          impressionLink: "https://bit.ly/41740VL",
          descr: "",
          image_url: "/static/other-sites/raycast-network.webp",
          disabled: false
        },
        {
          key: "play-1",
          title: "Play",
          short_title: "Native Prototypes. No App Install.",
          link: "https://apple.co/4cz6Nu6",
          impressionLink: "https://bit.ly/4adrJoG",
          descr: "Native Prototypes. No App Install.",
          image_url: "/static/other-sites/play-1.png",
          disabled: false
        },
        {
          key: "thestocks",
          title: "The Stocks",
          link: "http://v3.thestocks.im?ref=flatuicolors.com",
          descr: "Free stock photo websites.",
          image_url: "/static/other-sites/thestocks.png",
          disabled: true
        },
        {
          key: "peerlist",
          title: "Peerlist",
          short_title: "",
          link: "https://bit.ly/3JKxpeQ",
          impressionLink: "https://bit.ly/46AG2SS",
          descr: "Join the Professional Network",
          image_url: "/static/other-sites/peerlist.jpg",
          disabled: true
        },
        {
          key: "figmayo-1",
          title: "",
          short_title: "",
          link: "https://bit.ly/3LBAuPe",
          impressionLink: "https://bit.ly/3LGFl1w",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/figmayo-1.jpg",
          disabled: true
        },
        {
          key: "focusee-1",
          title: "",
          short_title: "",
          link: "https://bit.ly/3uTTC5I",
          impressionLink: "https://bit.ly/3TmJwUP",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/focusee.png",
          disabled: false
        },
        {
          key: "mobbin-1",
          title: "",
          short_title: "",
          link: "https://bit.ly/450nXxv",
          impressionLink: "https://bit.ly/4bksEnU",
          descr: "",
          noCurtain: true,
          image_url: "/static/other-sites/mobbin-network.jpg",
          disabled: false
        },
        {
          key: "e0b25",
          title: "Material UI",
          short_title: "Material UI Colors",
          link: "http://bit.ly/2IArB6d",
          descr: "Copy & Paste Colors.",
          image_url: "/static/other-sites/materialui.png",
          disabled: true
        },
        {
          key: "zeplin-3",
          title: "",
          short_title: "",
          link: "https://bit.ly/3V93JOt",
          impressionLink: "https://bit.ly/3URuV2X",
          descr: "",
          image_url: "/static/other-sites/zeplin-3.jpg",
          disabled: false
        },
        {
          key: "designcode",
          title: "Framer & Figma Components",
          short_title: "Design + Code UI",
          link: "https://bit.ly/3stw6M2",
          impressionLink: "https://bit.ly/3ufqSUy",
          descr: "300 Components",
          image_url: "/static/other-sites/designcode.jpg",
          disabled: true
        },
        {
          key: "streamlineicons",
          title: "Streamline",
          descr: "The Only Icon System",
          link: "https://bit.ly/3Xi1bgk",
          impressionLink: "https://bit.ly/3NazdyE",
          image_url: "/static/other-sites/streamlineicons-7.png",
          disabled: true
        },
        {
          key: "unijump",
          title: "UniJump",
          descr: "Free & Open Source ChatGPT Shortcut.",
          link: "https://bit.ly/3LmC47P",
          image_url: "/static/other-sites/unijump.jpg",
          disabled: true
        },
        {
          key: "4766c",
          title: "CollectUI",
          short_title: "Design Inspiration",
          link: "https://bit.ly/2IoXbYu",
          descr: "Categorized design inspiration.",
          image_url: "/static/other-sites/collectui.png",
          disabled: true
        },
        {
          key: "untitledui",
          title: "Untitled UI",
          short_title: "Most Popular Figma UI Kit",
          link: "https://bit.ly/3XeXNTD",
          impressionLink: "https://bit.ly/3JlMovm",
          descr: "Most Popular Figma UI Kit.",
          image_url: "/static/other-sites/untitledui.png",
          disabled: true
        },
        {
          key: "blush",
          title: "Blush Design",
          descr: "Free Illustrations",
          link: "http://bit.ly/3f00OTz",
          image_url: "/static/other-sites/blush.png",
          disabled: true
        },
        {
          key: "play",
          title: "Play",
          descr: "Native iOS design tool",
          link: "https://bit.ly/3R7a3RB",
          image_url: "/static/other-sites/play.png",
          disabled: true
        }
      ];
      this.sponsors = _.filter(this.sponsors, { disabled: false });

      //ROTATING SLOT
      //   this.sponsors.unshift(_.sample(_.filter(this.sponsorsRotation, {
      //     disabled: false
      //   })));

      // ROTATING SLOT
        this.sponsors.push(_.sample(_.filter(this.sponsorsRotation2, {
          disabled: false
        })));

      //SHARED SLOT
      let sharedSlotItems = _.shuffle(_.filter(this.sponsorsShared, {
        disabled: false
      }));
      let lastSharedSponsorNum = parseInt(
        localStorage.getItem("lastSharedSponsorNum")
      );
      if (!Number.isInteger(lastSharedSponsorNum)) {
        lastSharedSponsorNum = -1;
      }
      lastSharedSponsorNum =
        (lastSharedSponsorNum + 1) % sharedSlotItems.length;
      localStorage.setItem("lastSharedSponsorNum", lastSharedSponsorNum);
      this.sponsors.push(sharedSlotItems[lastSharedSponsorNum]);

      // SHARED SLOT # 2
      // AGAIN SHARED SLOT
      lastSharedSponsorNum = parseInt(
        localStorage.getItem("lastSharedSponsorNum")
      );
      if (!Number.isInteger(lastSharedSponsorNum)) {
        lastSharedSponsorNum = -1;
      }
      lastSharedSponsorNum =
        (lastSharedSponsorNum + 1) % sharedSlotItems.length;
      localStorage.setItem("lastSharedSponsorNum", lastSharedSponsorNum);
      this.sponsors.push(sharedSlotItems[lastSharedSponsorNum]);
      //SHARED SLOT END
      // SHARED SLOT # 3
      //AGAIN SHARED SLOT
      // lastSharedSponsorNum = parseInt(
      //   localStorage.getItem("lastSharedSponsorNum")
      // );
      // if (!Number.isInteger(lastSharedSponsorNum)) {
      //   lastSharedSponsorNum = -1;
      // }
      // lastSharedSponsorNum =
      //   (lastSharedSponsorNum + 1) % sharedSlotItems.length;
      // localStorage.setItem("lastSharedSponsorNum", lastSharedSponsorNum);
      // this.sponsors.push(sharedSlotItems[lastSharedSponsorNum]);
      // SHARED SLOT END

    //   DORA SLOT
    //   AGAIN SHARED SLOT
      // let doraSlotItems = _.shuffle(_.filter(this.sponsorsDora, {
      //   disabled: false
      // }));
      // let lastDoraSharedSponsorNum = parseInt(
      //   localStorage.getItem("lastSharedSponsorNum")
      // );
      // if (!Number.isInteger(lastDoraSharedSponsorNum)) {
      //     lastDoraSharedSponsorNum = -1;
      // }
      // lastDoraSharedSponsorNum =
      //   (lastDoraSharedSponsorNum + 1) % doraSlotItems.length;
      // localStorage.setItem("lastSharedSponsorNum", lastDoraSharedSponsorNum);
      // this.sponsors.unshift(doraSlotItems[lastDoraSharedSponsorNum]);
      //DORA SLOT END

      if (firstTime) {
        this.lastSponsorNum = _.random(this.enabledSponsors.length - 1);
        this.selectSponsor(this.lastSponsorNum);
      } else {
        this.selectSponsor(this.lastSponsorNum);
      }
      localStorage.setItem(
        "lastSponsorNum",
        (this.lastSponsorNum + 1) % this.enabledSponsors.length
      );
      that.setNextSponsorTimer();

      // inView(".other-websites").on("enter", () => {
      //   this.log("❤️ INVIEW AGAIN");
      //   that.logImpression();
      // });

      document.addEventListener(
        "visibilitychange",
        () => {
          this.log("🌎 VISIBILITY CHANGE");
          that.logImpression();
        },
        false
      );

      window.addEventListener(
        "focus",
        () => {
          this.log("👓 WINDOW FOCUS CHANGE");
          that.logImpression();
        },
        false
      );
    }
  },
  destroyed() {
    console.log("destroyed");
  },
  methods: {
    log(...text) {
      if (process.env.NODE_ENV === "development") {
        console.log(...text);
      }
    },
    onSponsorClick() {
      sendActivity(
        "FUIC_BANNER_AD_CLICK",
        `${this.activeSponsor.key}:${this.lastSponsorNum}`
      );
      this.log("Logging Click");
    },
    onSponsorHover: function() {
      clearTimeout(this.nextSponsorTimer);
    },
    onSponsorLeave: function() {
      this.setNextSponsorTimer();
    },
    setNextSponsorTimer() {
      clearTimeout(this.nextSponsorTimer);
      this.nextSponsorTimer = null;
      clearTimeout(this.nextSponsorDelayTimer);
      this.nextSponsorDelayTimer = setTimeout(() => {
        this.nextSponsorTimer = setTimeout(() => {
          this.selectSponsor(
            (this.lastSponsorNum + 1) % this.enabledSponsors.length,
            false
          );
        }, 7000);
      }, 2000);
    },
    selectSponsor(newIndex, sendEvent = false) {
      if (newIndex > this.enabledSponsors.length - 1) newIndex = 0;
      clearTimeout(this.nextSponsorDelayTimer);
      this.activeSponsor = this.enabledSponsors[newIndex];
      this.lastSponsorNum = newIndex;
      this.activeSponsorImpressionLogged = false;
      this.logImpression();
      this.setNextSponsorTimer();
    },
    logImpression(order, campaign_id) {
      return;
      this.log("♻️ Trying to log impression");
      if (!inView.is(document.querySelector(".other-websites"))) {
        this.log("🌶 Not inview");
        return;
      }
      if (this.activeSponsor.title === "...") {
        this.log("🌶 No active sponsor");
        return;
      }
      if (
        !this.activeSponsorImpressionLogged &&
        document.visibilityState !== "hidden" &&
        document.hasFocus()
      ) {
        this.log("👍 Logging Impression");
        this.activeSponsorImpressionLogged = true;
        sendActivity(
          "FUIC_BANNER_AD_SHOW",
          `${this.activeSponsor.key}:${this.lastSponsorNum}`
        );
      } else if (this.activeSponsorImpressionLogged) {
        this.log("🌶 Already logged");
      } else if (document.visibilityState === "hidden") {
        this.log("🌶 Document hidden");
      } else if (!document.hasFocus()) {
        this.log("🌶 Document doesn't have focus");
      }
    },
    animateEmoji: function() {
      if (this.isAnimating) return false;
      this.isAnimating = true;
      this.changeEmoji();
      this.interval = setInterval(this.changeEmoji, 500);
      // this.log('animating');
    },
    stopAnimateEmoji: function() {
      clearInterval(this.interval);
      this.emoji = this.paletteInfo.emoji;
      this.isAnimating = false;
    },
    changeEmoji: function() {
      this.emoji = this.paletteInfo.emojis[this.emojiIndex];
      this.emojiIndex = (this.emojiIndex + 1) % 4;
      // this.log('animation called');
    }
  }
};
</script>
<style lang="scss" scoped>
.smallpalette-container.other-websites {
  position: relative;
  padding: 0px;
  border-radius: 6px;
  background: none;
  &:active {
    transform: initial;
  }
  .slider {
    height: 15px;
    width: 100%;
    left: 0px;
    padding: 5px 11px;
    box-sizing: border-box;
    position: absolute;
    bottom: 8px;
    z-index: 50;
    a {
      width: 22.75%;
      height: 4px;
      background: #fff;
      display: inline-block;
      float: left;
      margin-right: 3%;
      opacity: 0.3;
      transition: all 0.2s;
      margin-top: 0px;
      &.selected {
        opacity: 1;
      }
      &:last-child {
        margin: 0px;
      }
    }
  }
  .website {
    position: absolute;
    z-index: 20;
    width: 100%;
    height: 100%;
    transition: all 0.2s;
    &:active {
      transform: scale(0.98);
    }
    &:hover {
      box-shadow: 0px 0px 20px #4368d1;
    }
  }
  .curtain {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 20;
    top: 0;
    background-image: linear-gradient(
      -180deg,
      rgba(0, 0, 0, 0) 0%,
      #0c2461 100%
    );
    &.noCurtain{
    background-image: linear-gradient(
      -180deg,
      rgba(0, 0, 0, 0) 70%,
      #0c2461 100%
    );
    }
    background: none !important;
    border-radius: 6px;
    display: block;
    padding: 10px;
    box-sizing: border-box;
    color: #fff;
    font-weight: bold;
    background-size: 110%;
    transition: all 0.2s;
    .title {
      font-size: 24px;
      width: 100%;
      display: inline-block;
      margin-bottom: 7px;
      margin-top: 142px;
      color: #fff;
    }
    .descr {
      font-size: 16px;
      color: #fff;
    }
    &:hover {
      background-size: 125%;
    }
  }
  .image {
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    z-index: 0;
    border-radius: 6px;
    background-size: cover;
    background-repeat: no-repeat;
    background-color: #000;
  }
  &:hover {
    // top: -2px;
    .loader-pie {
      display: none;
    }
    .slider {
      a {
        height: 8px;
        margin-top: -2px;
      }
    }
  }
}
.smallpalette-container {
  display: block;
  // width: 280px;
  width: 100%;
  height: 230px;
  background: #fff;
  border-radius: 4px;
  padding: 0px 10px;
  box-sizing: border-box;
  padding-top: 9px;
  transition: all 0.2s;
  &:active {
    transform: scale(0.97);
  }
  .colors {
    width: 100%;
    border-radius: 4px;
    height: calc(100% - 40px);
    float: left;
    .color {
      width: 20%;
      float: left;
      height: 25%;
      background: green;
      &:nth-child(1) {
        border-top-left-radius: 4px;
      }
      &:nth-child(5) {
        border-top-right-radius: 4px;
      }
      &:nth-child(16) {
        border-bottom-left-radius: 4px;
      }
      &:nth-child(20) {
        border-bottom-right-radius: 4px;
      }
    }
  }
  .name {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    height: 40px;
    line-height: 40px;
    float: left;
    width: 100%;
    text-align: left;
    text-indent: 2px;
    letter-spacing: 0.55px;
    .emoji {
      float: right;
      display: inline-block;
      margin-right: 4px;
      font-size: 20px;
    }
  }
}

@media (max-width: 600px) {
  .smallpalette-container {
    width: 100%;
    position: relative;
  }
}

//LOADER

.loader-pie {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: #fff;
  overflow: hidden;
  z-index: 40;
  right: 12px;
  top: 10px;
  opacity: 0.5;
}

.leftHalf,
.rightHalf,
.spinner {
  top: 0;
  position: absolute;
  width: 50%;
  height: 100%;
}

.leftHalf {
  left: 0;
  background: #fff;
  z-index: 3;
  opacity: 1;
  -webkit-animation: showHide 7s 1 steps(1, end);
  border-radius: 100% 0 0 100%/ 50% 0 0 50%;
}

.rightHalf {
  right: 0;
  background: #273c75;
  z-index: 1;
  opacity: 0;
  -webkit-animation: showHide 7s 1 steps(1, end) reverse;
  border-radius: 0 100% 100% 0/ 0 50% 50% 0;
}

.spinner {
  left: 0;
  background: #273c75;
  -webkit-animation: spin 7s linear 1;
  -webkit-transform-origin: center right;
  z-index: 2;
  border-radius: 100% 0 0 100%/ 50% 0 0 50%;
}

@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@-webkit-keyframes showHide {
  0% {
    opacity: 1;
  }

  50%,
  100% {
    opacity: 0;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/SmallPalette.vue